import { render, staticRenderFns } from "./Downtime.vue?vue&type=template&id=7b80535d&scoped=true"
import script from "./Downtime.vue?vue&type=script&lang=ts"
export * from "./Downtime.vue?vue&type=script&lang=ts"
import style0 from "./Downtime.vue?vue&type=style&index=0&id=7b80535d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b80535d",
  null
  
)

export default component.exports